import { render, staticRenderFns } from "./choosestaff.vue?vue&type=template&id=bff844dc&scoped=true"
import script from "./choosestaff.vue?vue&type=script&lang=js"
export * from "./choosestaff.vue?vue&type=script&lang=js"
import style0 from "./choosestaff.vue?vue&type=style&index=0&id=bff844dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff844dc",
  null
  
)

export default component.exports